'use client'

import { isAxiosError } from 'axios'
import { errorAnalyticsPayload } from '@/utilities/analytics/errorAnalytics'
import { nextApiClient } from '@/platform/http/nextApiClient'
import type { SyncPayloadUserInputType } from '@/types/next-api.generated'

export type SyncPayloadUserInput = SyncPayloadUserInputType

/**
 * Sync a user to Payload CMS for admin access.
 * Returns true on success, false on non-2xx, and never throws.
 */
export async function syncUserToPayload(input: SyncPayloadUserInput): Promise<boolean> {
  try {
    await nextApiClient.post_payload_users_sync({
      email: input.email,
      name: input.name,
      orgSlug: input.orgSlug,
      partnerId: input.partnerId,
      scopes: input.scopes || {},
    })
    return true
  } catch (error) {
    // Expected auth/validation failures (missing session, wrong email/org) are warn-level;
    // unexpected network/client errors stay error-level for dashboards.
    if (isAxiosError(error) && error.response) {
      console.warn(
        'Failed to sync user to Payload CMS:',
        error.response.status,
        error.response.statusText,
      )
      return false
    }

    console.error('Error syncing user to Payload CMS:', errorAnalyticsPayload(error))
    return false
  }
}

export const PayloadRepository = {
  syncUserToPayload,
}
